// extracted by mini-css-extract-plugin
export default {"languages-popover-button":"_hoyh4n","languagesPopoverButton":"_hoyh4n"};